import { render, staticRenderFns } from "./CertificateMobile.vue?vue&type=template&id=4b0ac8f0&scoped=true&"
import script from "./CertificateMobile.vue?vue&type=script&lang=ts&"
export * from "./CertificateMobile.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateMobile.vue?vue&type=style&index=0&id=4b0ac8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ac8f0",
  null
  
)

export default component.exports